import type { PageLoad } from './$types';
import survey from '../content/survey.yaml';
import { interpretSurvey } from '$lib/utils/surveyInterpreter';

export const prerender = true;

export const load = (async () => {
  if (!survey) {
    throw new Error('Survey data is required');
  }

  const processedSurvey = interpretSurvey(survey);
  
  if (!processedSurvey || !processedSurvey.theme) {
    throw new Error('Survey processing failed');
  }

  return {
    survey: processedSurvey
  };
}) satisfies PageLoad; 